module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingstatus),
      expression: "loadingstatus"
    }],
    staticClass: "pl10px pr10px ibox-content",
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label t_right"
  }, [_vm._v("服务卡号")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.vehicleAccount),
      expression: "vehicleInfo.vehicleAccount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.vehicleInfo.vehicleAccount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "vehicleAccount", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label t_right",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("服务状态")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.vehicleInfo.serverStatus),
      expression: "vehicleInfo.serverStatus",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vehicleInfo, "serverStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("空闲中")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("已暂停")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("救援中")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label t_right"
  }, [_vm._v("服务结束日")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.serviceEndTime),
      expression: "vehicleInfo.serviceEndTime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.vehicleInfo.serviceEndTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "serviceEndTime", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label t_right"
  }, [_vm._v("服务起始日")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.serviceStartTime),
      expression: "vehicleInfo.serviceStartTime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.vehicleInfo.serviceStartTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "serviceStartTime", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label t_right red"
  }, [_vm._v("*车牌号")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4",
    class: {
      'form-group--error': _vm.$v.vehicleInfo.plateNumber.$error
    }
  }, [_c('vplate-input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.$v.vehicleInfo.plateNumber.$touch()
      }
    },
    model: {
      value: (_vm.vehicleInfo.plateNumber),
      callback: function($$v) {
        _vm.$set(_vm.vehicleInfo, "plateNumber", $$v)
      },
      expression: "vehicleInfo.plateNumber"
    }
  }), _vm._v(" "), (!_vm.$v.vehicleInfo.plateNumber.required && _vm.$v.vehicleInfo.plateNumber.$error) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("车牌号为必填项")]) : _vm._e()], 1), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label t_right red"
  }, [_vm._v("*车辆类型")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4",
    class: {
      'form-group--error': _vm.$v.vehicleInfo.style.$error
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.style),
      expression: "vehicleInfo.style"
    }],
    staticClass: "form-control",
    on: {
      "input": function($event) {
        return _vm.$v.vehicleInfo.style.$touch()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vehicleInfo, "style", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.udcList), function(item) {
    return _c('option', {
      domProps: {
        "value": item.udccode
      }
    }, [_vm._v(_vm._s(item.udcname))])
  }), 0), _vm._v(" "), (!_vm.$v.vehicleInfo.style.required && _vm.$v.vehicleInfo.style.$error) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("车辆类型为必填项")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label t_right"
  }, [_vm._v("载重量(吨)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.maximumLoadStr),
      expression: "vehicleInfo.maximumLoadStr"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.vehicleInfo.maximumLoadStr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "maximumLoadStr", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label t_right red"
  }, [_vm._v("*调度电话")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4",
    class: {
      'form-group--error': _vm.$v.vehicleInfo.dispatcherPhone.$error
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.dispatcherPhone),
      expression: "vehicleInfo.dispatcherPhone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.vehicleInfo.dispatcherPhone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "dispatcherPhone", $event.target.value)
      }, function($event) {
        return _vm.$v.vehicleInfo.dispatcherPhone.$touch()
      }]
    }
  }), _vm._v(" "), (!_vm.$v.vehicleInfo.dispatcherPhone.required && _vm.$v.vehicleInfo.dispatcherPhone.$error) ? _c('span', {
    staticClass: "form-group__message cus_message"
  }, [_vm._v("调度电话为必填项")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label t_right"
  }, [_vm._v("车辆照片")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "uploadedImg t_right col-sm-3"
  }, [(_vm.logoSrc !== '') ? _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.logoSrc
    }
  }) : _vm._e(), _vm._v(" "), (_vm.logoSrc == '') ? _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("../../../../assets/project/images/img_bg.jpg")
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.permission.indexOf('carFileList_uploadRescueVehiclePhoto') == -1) ? _c('vue-core-image-upload', {
    class: ['upload-pic'],
    attrs: {
      "extensions": "png,gif,jpeg,jpg",
      "input-accept": "image/jpg,image/jpeg,image/png",
      "crop": false,
      "text": "",
      "inputOfFile": "file",
      "url": _vm.picUrl,
      "headers": {
        'access-token': this.accesstoken
      }
    },
    on: {
      "imageuploaded": _vm.imageuploaded
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: " control-label gray t_right"
  }, [_vm._v("请上传jpg、jpeg或png格式的图片")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal col-sm-8"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label t_right "
  }, [_vm._v("服务项目:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, _vm._l((_vm.serviceArr), function(item) {
    return (_vm.vehicleInfo.style == 10 || item.udccode !== 1) ? _c('div', {
      staticClass: "col-sm-3 control-label"
    }, [_c('checkbox', {
      model: {
        value: (item.type),
        callback: function($$v) {
          _vm.$set(item, "type", $$v)
        },
        expression: "item.type"
      }
    }, [_vm._v(_vm._s(item.udcname))])], 1) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal ibox-content"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [(_vm.permission.indexOf('carFileList_forcedUnlockDriver') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.vehicleInfo.driverName == ''
    },
    on: {
      "click": _vm.unBindBtn
    }
  }, [_vm._v("强制解绑司机")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label t_right"
  }, [_vm._v("在驾司机:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.driverName),
      expression: "vehicleInfo.driverName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.vehicleInfo.driverName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "driverName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_right"
  }, [_vm._v("手机号:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.driverPhone),
      expression: "vehicleInfo.driverPhone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.vehicleInfo.driverPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "driverPhone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-1 control-label t_right"
  }, [_vm._v("绑定时间:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.bindTime),
      expression: "vehicleInfo.bindTime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.vehicleInfo.bindTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "bindTime", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label t_right"
  }, [_vm._v("工作备注:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-11"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleInfo.memo),
      expression: "vehicleInfo.memo"
    }],
    staticClass: "col-sm-12",
    attrs: {
      "rows": "6",
      "maxlength": "250"
    },
    domProps: {
      "value": (_vm.vehicleInfo.memo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleInfo, "memo", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "col-sm-11"
  }, [(_vm.permission.indexOf('carFileList_saveBasicInfo') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.enableSubmit
    },
    on: {
      "click": _vm.saveVehicle
    }
  }, [_vm._v("\n\t\t\t\t\t保存基本信息\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.permission.indexOf('carFileList_inIdleStatus') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.vehicleInfo.serverStatus == 1 || _vm.vehicleInfo.driverId == '' || _vm.vehicleInfo.driverId == 0
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(1)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t切入空闲状态\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.permission.indexOf('carFileList_inPauseStatus') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.vehicleInfo.serverStatus == 2 || _vm.vehicleInfo.driverId == '' || _vm.vehicleInfo.driverId == 0
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(2)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t切入暂停状态\n\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [(_vm.permission.indexOf('carFileList_deleteRescueVehicle') == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.openModal('deleteCar')
      }
    }
  }, [_vm._v("删除车辆")]) : _vm._e()])])])]), _vm._v(" "), _c('tab-modal', {
    ref: "deleteCar",
    attrs: {
      "size": "small",
      "scroll": _vm.scrollTop,
      "title": "提示"
    },
    on: {
      "cancel": function($event) {
        return _vm.closeModal('deleteCar')
      }
    }
  }, [(_vm.toShowMsg) ? _c('p', [_vm._v("\t\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t您将要删除车辆“" + _vm._s(_vm.vehicleInfo.plateNumber) + "”，删除后该车辆将不能查询、接单。如有误删除，需与人保客服联系解除。\n\t\t\t\t您确定要继续吗？\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.removeCar
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.closeModal('deleteCar')
      }
    }
  }, [_vm._v("取消")])])]), _vm._v(" "), _c('tab-modal', {
    ref: "unBind",
    attrs: {
      "size": "small",
      "scroll": _vm.scrollTop,
      "title": "提示"
    },
    on: {
      "cancel": function($event) {
        return _vm.closeModal('unBind')
      }
    }
  }, [(_vm.toShowMsg) ? _c('p', [_vm._v("您将强制解除司机“" + _vm._s(_vm.vehicleInfo.driverName) + "”与“" + _vm._s(_vm.vehicleInfo.plateNumber) + "”的绑定关系，\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t解除后，该车辆可由其它司机上岗驾驶。\t\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t您确定要继续吗？")]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.forceUnbind
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.closeModal('unBind')
      }
    }
  }, [_vm._v("取消")])])]), _vm._v(" "), _c('tab-modal', {
    ref: "modalMsg",
    attrs: {
      "size": "small",
      "scroll": _vm.scrollTop,
      "title": "提示"
    },
    on: {
      "cancel": function($event) {
        return _vm.closeModal('modalMsg')
      }
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.messageStr) + "\t\t\t\t\t\t\t\t\t\t\t\n\t\t"), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.closeModal('modalMsg')
      }
    }
  }, [_vm._v("取消")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a01b918","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/carfile/detail/DetailBasic.vue
// module id = 1452
// module chunks = 0